//We are settings an initial state here for clarity, probably is not needed

const Settings = {
  App: "data-worker",
  Name: "data-worker",

  baseURl: "./",
  BasePathForAPI: "https://api.dataworker.com.do/api/",

  BasePath: "https://api.dataworker.com.do/",
  AppURL: "https://dataworker.com.do/",
  // BasePathForAPI: "https://localhost:44322/api/",
  // BasePath: "https://localhost:44322/",
  GoogleMapsAPIKey: "AIzaSyBYmH6z_csu0XTQ8JO5ZK1iquSzk6LrKpU",
  SocketPath: "",
  SyncFusionKey: "",
}

export default Settings
